var _defs, _g, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 54.5,
    x2: 89.2,
    y1: 2.2,
    y2: 62.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 31.4,
    x2: 68.3,
    y1: 37.6,
    y2: 101.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: -2197.1,
    x2: -2077,
    y1: 5168.6,
    y2: 5376.7,
    gradientTransform: "rotate(45 5106 5660.004)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -2191.4,
    x2: -2110.1,
    y1: 5157.8,
    y2: 5298.6,
    gradientTransform: "rotate(45 5106 5660.004)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f87171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc2626"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 138 96"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeDasharray: 58,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M105.2 10.8A15.6 15.6 0 11116.4 37H6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0; 1274"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#b)",
    strokeDasharray: 43,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M60.7 85.2A15.6 15.6 0 1071.9 59H6.6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0; 857"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M304 355a24 24 0 01-48 0V133",
    transform: "rotate(45 256 256)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 256 256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#ef4444",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M376 237c0-53-53.7-96-120-96s-120 43-120 96l12.7-5.8c18-8.3 41-8 58.5.5l11 5.3 6.8-3.5a70.8 70.8 0 0162 0l6.8 3.5 11-5.3a71.1 71.1 0 0158.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M293.8 237c6.6-53.6-37.8-96-37.8-96s-44.4 42.4-37.8 96"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1; .9 1.1; 1 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 0; 29 -14; 0 0"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 138,
    height: 96,
    transform: "translate(62.5 201)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.f89d281edd4ece57ea33e1510039a524.svg";
export { ForwardRef as ReactComponent };